import { modalAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/styled-system';
import { ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeRadiusToken, } from '../theme-tokens';
import { buttonConfig } from './button-theme';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = definePartsStyle({
    overlay: {
        // Non white label-overridable color based on black, always
        bg: 'rgba(0, 0, 0, 0.32)',
    },
    header: {
        bg: ThemeColorToken.Surface,
        position: 'relative',
        fontSize: ThemeFontSizeToken.XLarge,
        fontFamily: ThemeFontToken.SubHeader,
        color: ThemeColorToken.OnSurfaceHeader,
        fontWeight: 'medium',
        borderTopRadius: ThemeRadiusToken.Large,
        minHeight: '72px',
        px: 0,
        py: 0,
    },
    body: {
        borderTopRadius: ThemeRadiusToken.Large,
        fontFamily: ThemeFontToken.Body,
        px: 0,
        py: 0,
    },
    dialog: {
        maxW: '384px',
        my: '48px',
        borderRadius: ThemeRadiusToken.Large,
        bg: ThemeColorToken.Surface,
        color: ThemeColorToken.OnSurface,
    },
    dialogContainer: {
        height: '100dvh',
    },
    footer: {
        borderBottomRadius: ThemeRadiusToken.Large,
        bg: ThemeColorToken.Surface,
        px: 0,
        py: 0,
    },
    closeButton: {
        width: '40px',
        minW: '40px',
        maxW: '40px',
        height: '40px',
        minH: '40px',
        maxH: '40px',
        position: 'relative',
        zIndex: '0',
        right: 'unset',
        top: 'unset',
        alignSelf: 'flex-start',
        ...buttonConfig.baseStyle,
        ...buttonConfig.variants?.secondary,
    },
});
const sizes = {
    sm: definePartsStyle({
        dialog: {
            maxW: '384px',
        },
    }),
    md: definePartsStyle({
        dialog: {
            maxW: '560px',
            mx: '48px',
        },
    }),
    lg: definePartsStyle({
        dialog: {
            maxW: '960px',
            mx: '80px',
        },
    }),
    xl: definePartsStyle({
        dialog: {
            maxW: '100%',
            mx: '80px',
        },
    }),
    full: definePartsStyle({
        dialog: {
            borderRadius: 0,
        },
        body: {
            borderRadius: 0,
        },
        header: {
            borderRadius: 0,
        },
        footer: {
            borderRadius: 0,
        },
    }),
};
const variants = {
    /** Custom variant appearing as a mobile app "bottom sheet",
     * filling 100% of view width and max 100% - 88px view height. */
    bottomSheet: definePartsStyle({
        dialog: {
            maxW: '100vw',
            maxHeight: 'calc(100dvh - 88px)',
            borderBottomRadius: 0,
            margin: 0,
        },
        footer: {
            borderBottomRadius: 0,
        },
        dialogContainer: {
            alignItems: 'flex-end',
        },
    }),
};
export const modalConfig = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
});
//# sourceMappingURL=modal-theme.js.map